// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"vw_a bhh_b"};